import { render, staticRenderFns } from "./CompetitionMgmt.vue?vue&type=template&id=744c93c4"
import script from "./CompetitionMgmt.vue?vue&type=script&lang=js"
export * from "./CompetitionMgmt.vue?vue&type=script&lang=js"
import style0 from "./CompetitionMgmt.vue?vue&type=style&index=0&id=744c93c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports